
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    async fetch() {
        try {
            await this.getCategories();
        } catch (error) {
            this.$bugsnag.notify(new Error(error));
            console.log({ error });
        }
    },
    computed: {
        ...mapGetters('location', ['location', 'locationLoading']),
        ...mapGetters('restaurants', ['categories']),
        ...mapGetters('order', ['deliveryMethod', 'address']),
        ...mapGetters('ghostState', ['allPagesLoaded']),
        searchParams() {
            return {
                location: this.location,
            };
        },
        states(){
          return Object.is(this.$fetchState, undefined) ? true : this.$fetchState.pending;
        },
    },
    watch: {
        searchParams: {
            handler() {
                this.$fetch();
            },
            deep: true,
        },
        states: function(val){
          this.updateState({page:"restaurantCategories", pending: val})
        },
    },
    methods: {
        ...mapActions('restaurants', ['getCategories']),
        ...mapMutations('ghostState', ['updateState'])
    },
};
